import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { patchColumnData } from "app/static/frontend/sheets/sheet-action-creators"

import { EnumDisplayCell, EnumSelectCell } from "app/static/frontend/sheets/components/cells/MantineCells"

// get the enum values
const e = DjangIO.app.userdata.types.LegislativePriorityType

// a component to render the strings instead of the enums in sheets
export const UnconnectedBillPriorityCell = ({ editing, children, ...props }) => {
    // if we are editing, render the select cell
    if (editing) {
        return <EnumSelectCell choices={e} item={e.by_value(children)} {...props} />
        // otherwise, just render the label for the enum
    } else {
        return <EnumDisplayCell choices={e} item={e.by_value(children)} {...props} />
    }
}

UnconnectedBillPriorityCell.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    editing: PropTypes.bool.isRequired,
}

export const BillPriorityCell = connect(null, { patchColumnData })(UnconnectedBillPriorityCell)
